import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Printer, FileText, Sun, Moon } from "lucide-react";
import { OFFER } from "./data";

export const TopBar = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("vofe-theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    localStorage.setItem("vofe-theme", theme);
  }, [theme]);

  return (
    <motion.header
      data-testid="top-bar"
      initial={{ y: -70 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 1.6 }}
      className="print-hidden fixed inset-x-0 top-0 z-50 border-b border-line bg-base/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <FileText className="h-5 w-5 text-accent" />
          <span className="font-mono2 text-[11px] tracking-[0.25em] text-ink4 uppercase">
            {OFFER.ref}
          </span>
        </div>
        <div className="flex items-center gap-3">
          <button
            data-testid="theme-toggle-button"
            onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
            aria-label="Toggle light / dark mode"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-line text-ink4 transition-[background-color,color,border-color] duration-300 hover:border-amber-500 hover:text-accent"
          >
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
          <button
            data-testid="print-pdf-button"
            onClick={() => window.print()}
            className="group flex items-center gap-2 rounded-full border border-amber-500/50 px-5 py-2 text-xs font-semibold tracking-wider text-accent uppercase transition-[background-color,color,border-color] duration-300 hover:bg-amber-500 hover:text-[#0b0f17]"
          >
            <Printer className="h-4 w-4 transition-transform duration-300 group-hover:-rotate-12" />
            Print / PDF
          </button>
        </div>
      </div>
    </motion.header>
  );
};
